import axiosInstance from "auth/FetchInterceptor";
import { DRIVER_FINDING_RULE_API } from "constants/ApiConstant";
const DriverFindingRuleService = {};

DriverFindingRuleService.getDriverFindingRuleApi = function (data) {
  return axiosInstance.get(DRIVER_FINDING_RULE_API, data);
};

DriverFindingRuleService.updateDriverFindingRuleApi = function (data) {
  return axiosInstance.put(DRIVER_FINDING_RULE_API, data);
};

export default DriverFindingRuleService;
